export default __webpack_public_path__ + "partner_14ffae12.png";